import { z } from 'zod';
import { positiveDecimalSchema, currencyCodeSchema, isoDateSchema } from './common';

export const goalTypeSchema = z.enum(['saving', 'spending_limit', 'income_target']);
export type GoalType = z.infer<typeof goalTypeSchema>;

export const createGoalSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  type: goalTypeSchema,
  targetAmount: positiveDecimalSchema,
  currency: currencyCodeSchema.default('TRY'),
  startDate: isoDateSchema.optional(),
  endDate: isoDateSchema.optional(),
});
export type CreateGoalInput = z.infer<typeof createGoalSchema>;

export const updateGoalSchema = createGoalSchema.partial();
export type UpdateGoalInput = z.infer<typeof updateGoalSchema>;
